function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useMemo } from 'react';
import { getYear } from 'date-fns';
import { useLocale } from '@adsk/alloy-react-locale';
import { getWeekDaysShort, getMonths, convertYearRangeToArray, getFirstDayOfWeek } from '../helpers';
const monthsOfTheYear = T => [{
  key: 0,
  label: T.translate('JANUARY')
}, {
  key: 1,
  label: T.translate('FEBRUARY')
}, {
  key: 2,
  label: T.translate('MARCH')
}, {
  key: 3,
  label: T.translate('APRIL')
}, {
  key: 4,
  label: T.translate('MAY')
}, {
  key: 5,
  label: T.translate('JUNE')
}, {
  key: 6,
  label: T.translate('JULY')
}, {
  key: 7,
  label: T.translate('AUGUST')
}, {
  key: 8,
  label: T.translate('SEPTEMBER')
}, {
  key: 9,
  label: T.translate('OCTOBER')
}, {
  key: 10,
  label: T.translate('NOVEMBER')
}, {
  key: 11,
  label: T.translate('DECEMBER')
}];
function useCalendars(_ref) {
  let {
    activeMonths,
    selectedDates,
    minDate,
    maxDate,
    firstDayOfWeek: firstDayOfWeekProp,
    showOutsideDays,
    isDateSelectable,
    yearsToDisplay,
    timeZone
  } = _ref;
  const {
    T,
    locale
  } = useLocale(_ref2 => {
    let {
      locale: loc
    } = _ref2;
    return require("../i18n/".concat(loc, ".json"));
  });
  const firstDayOfWeek = getFirstDayOfWeek(locale, firstDayOfWeekProp);
  const weekdays = useMemo(() => getWeekDaysShort(T, firstDayOfWeek), [T, firstDayOfWeek]);
  return useMemo(() => activeMonths.map((month, index) => {
    const calendar = getMonths({
      month: month.month,
      year: month.year,
      selectedDates,
      minDate,
      maxDate,
      firstDayOfWeek,
      showOutsideDays,
      isDateSelectable,
      timeZone
    });
    const months = monthsOfTheYear(T);
    const years = convertYearRangeToArray({
      min: minDate ? getYear(minDate) : month.year - yearsToDisplay,
      max: maxDate ? getYear(maxDate) : month.year + yearsToDisplay,
      selectedDates
    });
    return _objectSpread(_objectSpread({}, calendar), {}, {
      index,
      months,
      weekdays,
      years,
      selectedMonth: months.find(_ref3 => {
        let {
          key
        } = _ref3;
        return key === calendar.month;
      }),
      selectedYear: years.find(_ref4 => {
        let {
          key
        } = _ref4;
        return key === calendar.year;
      })
    });
  }), [T, firstDayOfWeek, isDateSelectable, showOutsideDays, weekdays, yearsToDisplay, activeMonths, minDate, maxDate, selectedDates, timeZone]);
}
export default useCalendars;
//# sourceMappingURL=useCalendars.js.map